/**
 * A run whose content the server does not open to this reader
 * (agion/Agion#3019): where six-level governance is active, only the person
 * who started a run reads it here, and a run started by a schedule or a
 * trigger is read only from the audit page. The chat shows this line in
 * place of the messages. The server decides; the chat only says so.
 */
import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/** Initiator types of a run no person started. */
const AUTOMATIC_INITIATORS = new Set(['trigger', 'system'])

export interface ClosedConversationNoticeProps {
  /** The run's initiator_type, when the run detail said it. */
  initiatorType?: string
}

export function ClosedConversationNotice({ initiatorType }: ClosedConversationNoticeProps) {
  const { t } = useTranslation('chat')
  const automatic = initiatorType !== undefined && AUTOMATIC_INITIATORS.has(initiatorType)
  return (
    <div
      role="status"
      data-testid="closed-conversation-notice"
      className="mx-auto flex max-w-2xl items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200"
    >
      <Lock className="mt-0.5 h-4 w-4 flex-none" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        {automatic
          ? t('customer.conversationStartedAutomatically', 'This conversation was started by a schedule or a trigger, not by a person. Its content opens only from the audit page.')
          : t('customer.conversationOwnedByOther', 'This conversation belongs to another person. Only they can read it here.')}
      </p>
    </div>
  )
}
